import React from "react";

class Cookies extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accept: false
    };
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick() {
    this.setState({
      accept: !this.state.accept
    });
  }
  render() {
    return (
      <div
        className={
          this.state.accept ? "cookies-not-displayed" : "cookies-displayed"
        }
      >
        soju.studio uses cookies <a onClick={this.handleClick}>×</a>
      </div>
    );
  }
}
export default Cookies;



// WEBPACK FOOTER //
// /opt/build/repo/src/components/cookies.js